import { render, staticRenderFns } from "./IconsGroup.vue?vue&type=template&id=586fde38"
import script from "./IconsGroup.vue?vue&type=script&lang=js"
export * from "./IconsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports